import React from "react";
import {
  AudioMessage,
  ButtonReplyMessage,
  ContactsMessage,
  DocumentMessage,
  ImageMessage,
  InteractiveMessage,
  InteractiveReplyMessage,
  LocationMessage,
  ReactionMessage,
  StickerMessage,
  SystemMessage,
  TemplateMessage,
  TextMessage,
  UnsupportedMessage,
  VideoMessage,
} from "./MessageRender";

function MessageContent({ message, onInteractiveClick }) {
  const type = String(message?.type || "").toLowerCase();
  const payload = message?.payload;

  switch (type) {
    case "text":
      return <TextMessage payload={payload} />;

    case "image":
      return <ImageMessage payload={payload} />;

    case "video":
      return <VideoMessage payload={payload} />;

    case "audio":
      return <AudioMessage payload={payload} />;

    case "document":
      return <DocumentMessage payload={payload} />;

    case "interactive":
      if (payload?.type === "button_reply" || payload?.type === "list_reply") {
        return <InteractiveReplyMessage payload={payload} />;
      }
      return (
        <InteractiveMessage
          message={message}
          payload={payload}
          onInteractiveClick={onInteractiveClick}
        />
      );

    // customer tapped a quick-reply button on a template we sent
    case "button":
      return <ButtonReplyMessage payload={payload} />;

    case "template":
      return <TemplateMessage payload={payload} />;

    case "reaction":
      return <ReactionMessage payload={payload} />;

    case "contacts":
      return <ContactsMessage payload={payload} />;

    case "location":
      return <LocationMessage payload={payload} />;

    case "sticker":
      return <StickerMessage payload={payload} />;

    case "system":
      return <SystemMessage payload={payload} />;

    default:
      return <UnsupportedMessage type={type} />;
  }
}

export default MessageContent;
